/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentGetQueryResponse, ContentGetPathParams } from "../models/ContentGet";

export function getContentGetUrl(id: ContentGetPathParams["id"]) {
  const res = { method: 'GET', url: `/contents/${id}` as const }  
  return res
}

/**
 * @summary Get content by ID
 * {@link /contents/:id}
 */
export async function contentGet(id: ContentGetPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ContentGetQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getContentGetUrl(id).url.toString(), ... requestConfig })  
  return res.data
}